import medicoreLogoSmall from './assets/adapters/medicore-logo-small.png'
import nedapLogo from './assets/adapters/nedap-ons-logo.svg'
import sdbLogo from './assets/adapters/sdb-logo.svg'

export enum EHRAdapter {
    MEDICORE = 1,
    SDBUSER = 2,
    NEDAP = 3,
}

export const EHRAdapterMap: Record<number, string> = {
    [EHRAdapter.MEDICORE]: 'medicore',
    [EHRAdapter.SDBUSER]: 'sdbuser',
    [EHRAdapter.NEDAP]: 'nedap',
}
export const EHRAdapterLogoMap: Record<number, string> = {
    [EHRAdapter.MEDICORE]: medicoreLogoSmall,
    [EHRAdapter.SDBUSER]: sdbLogo,
    [EHRAdapter.NEDAP]: nedapLogo,
}

export const EHRAdapterDisplayNameMap: Record<string, string> = {
    medicore: 'Medicore',
    sdbuser: 'SDB User',
    nedap: 'Nedap ONS',
}

export interface AdapterCapabilities {
    requiresPatientFirst: boolean
    /**
     * The adapter exposes GET /adapters/{name}/patients/{id}. Only adapters whose external system
     * authorises the read itself can, so the rest cannot resolve a launch patient by id (MD-1452).
     */
    supportsPatientLookup: boolean
}

export const EHRAdapterCapabilities: Record<string, AdapterCapabilities> = {
    medicore: { requiresPatientFirst: false, supportsPatientLookup: true },
    sdbuser: { requiresPatientFirst: true, supportsPatientLookup: false },
    nedap: { requiresPatientFirst: false, supportsPatientLookup: false },
}

const defaultCapabilities: AdapterCapabilities = { requiresPatientFirst: false, supportsPatientLookup: false }

// Single resolution point for adapter identity/capabilities. When the manifest
// framework lands (see EHR Integration Framework design doc), these read from
// the fetched manifest instead of the static maps above.
export const getAdapterName = (ehrAdapter?: number | null): string | null =>
    ehrAdapter ? (EHRAdapterMap[ehrAdapter] ?? null) : null

export const getAdapterCapabilities = (ehrAdapter?: number | null): AdapterCapabilities => {
    const name = getAdapterName(ehrAdapter)
    return (name && EHRAdapterCapabilities[name]) || defaultCapabilities
}
